import * as React from 'react';
import { MdClosedCaption, MdClosedCaptionDisabled } from 'react-icons/md';
import { ControlsButton } from './videoPlayer/components/videoControls';

type CaptionsButtonProps = {
  showCaptions: boolean;
  captionOption: string;
  playerBackgroundColor: string;
  playerIconsColor: string;
  captionsAvailable: boolean;
  onClick: () => void;
};

export const CaptionsButton: React.FC<CaptionsButtonProps> = ({
  showCaptions,
  captionOption,
  playerBackgroundColor,
  playerIconsColor,
  captionsAvailable,
  onClick,
}) => {
  return (
    <ControlsButton
      active={showCaptions}
      color={playerBackgroundColor}
      onClick={onClick}
      disabled={!captionsAvailable}
    >
      {captionOption === 'off' ? (
        <MdClosedCaptionDisabled color={playerIconsColor} size={22} />
      ) : (
        <MdClosedCaption color={playerIconsColor} size={22} />
      )}
    </ControlsButton>
  );
};
